const CURRENCY_FORMATTER = new Intl.NumberFormat("en-CA", {
  currency: "CAD",
  style: "currency",
});

export const formatCurrency = (amount) => {
  return CURRENCY_FORMATTER.format(amount);
}

const NUMBER_FORMATTER = new Intl.NumberFormat("en-CA");

export const formatNumber = (number) => {
  return NUMBER_FORMATTER.format(number);
}